import PropTypes from 'prop-types'

import { Icon } from '../display/icon'

const IWantToIcon = ({ label = 'IWantTo', ...rest }) => {
  return (
    <Icon
      label={label}
      {...rest}
      dangerouslySetGlyph={`<svg data-name="Layer 1" viewBox="0 0 300 300"><circle cx="150" cy="150" r="117.2" style="fill:#b7cd65"/><path d="M150 32.8A117.2 117.2 0 1 1 32.8 150 117.4 117.4 0 0 1 150 32.8m0-10C79.9 22.8 22.8 79.9 22.8 150S79.9 277.2 150 277.2 277.2 220.1 277.2 150 220.1 22.8 150 22.8z" style="fill:#1d1d1b"/><path style="fill:#fff" d="m201.7 98.3-76 27.4-27.4 76 76-27.4 27.4-76z"/><path d="m201.7 98.3-27.4 76-76 27.4 27.4-76 76-27.4m0-10h-.6a13.3 13.3 0 0 0-3 .6l-75.8 27.4a9.9 9.9 0 0 0-6 6l-27.4 76a10 10 0 0 0 12.8 12.8l76-27.4a9.9 9.9 0 0 0 6-6L211 102a9.4 9.4 0 0 0 .7-3.7 10 10 0 0 0-9.7-10zm0 20z" style="fill:#1d1d1b"/><path d="M140.8 159.2a13 13 0 1 1 18.4 0 13 13 0 0 1-18.4 0z"/></svg>`}
    />
  )
}

IWantToIcon.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.oneOf(['tiny', 'small', 'medium', 'large'])
}

export { IWantToIcon }
